import { ModuleInfo } from '@/common/model-apis/type';
/**
 * 基于模型生成默认数据
 * @param module
 */
export function getInitValuesOfModule(module: ModuleInfo) {

}

/**
 * 获取模型主键
 * @param module
 * @returns string
 */
export function getPrimaryKeyOfModule(module?: ModuleInfo) {
  if (!module) {
    return null;
  }
  const field = module?.fields?.find(x => x.isPrimary);
  if (field) {
    return field.name;
  }
  return null;
}


export function composeRecord(data: { values: Array<{ name: string; value: any }> }): object {
  const res: any = {};
  // console.log('-----data', data)
  data.values.forEach(v => {
    res[v.name] = v.value;
  });
  return res;
}
